var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLofty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#3b5cde",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00519 14.8668C10.6216 13.4422 12.2397 12.0176 13.856 10.593C14.2307 10.2635 14.8427 10.2635 15.2174 10.593C17.933 12.9822 20.9424 15.6306 23.658 18.0199C24.2296 18.5245 23.9922 19.0119 23.6175 19.3432C21.9906 20.7764 20.274 22.2886 18.6453 23.7217C18.2531 24.0667 17.6586 24.1079 17.2506 23.7492C14.8902 21.6706 12.5299 19.5921 10.1713 17.5118C9.75973 17.1479 9.12303 17.1582 8.75016 17.4878C6.38102 19.5749 4.01188 21.6603 1.6445 23.7475C1.03595 24.2847 0 23.9054 0 23.1502C0 17.5993 0 12.0502 0 6.49939C0 6.26596 0.0949767 6.06514 0.281412 5.90037C2.42015 4.01748 4.55888 2.13287 6.69761 0.249982C7.30441 -0.283818 8.34036 0.0937898 8.34036 0.849006C8.34036 5.43866 8.34036 10.0283 8.34036 14.618C8.3386 14.9441 8.77479 15.0694 9.00519 14.8668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLofty);
export default __webpack_public_path__ + "static/media/lofty.f8a737c151b7a459723a75fe4c89f9f5.svg";
export { ForwardRef as ReactComponent };